import get from 'lodash/get.js';

const getStorePricing = product => (
  get(product, 'storeInfo.local.pricing') ||
  get(product, 'storeInfo.national.pricing')
);

export default getStorePricing;
